import React, { Component } from "react"
import { Container, Row, Col } from 'reactstrap'
import CarInspectionsListHeader from "./CarInspectionsListHeader"
import CarInspectionsList from "./CarInspectionsList"

class CarInspectionsContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            filterValues: {
                orderBy: ["-id"]
            },
        }
    }

    updateOrder = (string) => {
        let order = this.state.filterValues.orderBy ? [...this.state.filterValues.orderBy] : []
        let index = order.indexOf(string)
        if (index > -1) {
            order[index] = "-" + string
        } else {
            index = order.indexOf("-" + string)
            index > -1 ? order.splice(index, 1) : order.unshift(string)
        }
        this.setState((prevState) => ({ filterValues: { ...prevState.filterValues, orderBy: order } }))
    }

    render() {
        return (
            <Container fluid className="bos-listing-container">
                <CarInspectionsListHeader
                    filterValues={this.state.filterValues}
                    setFilterValues={(filterValues) => this.setState({ filterValues })}
                />
                <Row>
                    <Col>
                        <CarInspectionsList
                            orderBy={this.state.filterValues.orderBy || []}
                            updateOrder={this.updateOrder}
                            searchTerm={this.state.filterValues.searchTerm || null}
                            currentUser={this.props.currentUser}
                        />
                    </Col>
                </Row>
            </Container>
        )
    }
}

export default CarInspectionsContainer
